<template>
  <!-- 发货信息 -->
  <card class="wrapper">
    <AdminTitle title="发货信息" size="20px"></AdminTitle>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="serialNo" label="设备串号" :key="showEditButton">
        <template slot="header">
          <span>设备串号</span>
          <i
            v-if="showEditButton && isShowBtn(AUTH_BTN.order_list_detail_update_device_sn)"
            class="el-icon-edit"
            @click="editDeviceSn"
            style="margin-left: 5px; cursor: pointer; color: #409eff"
            title="修改设备串号"
          ></i>
        </template>
      </el-table-column>
      <el-table-column prop="costPrice" label="采购价"></el-table-column>
      <el-table-column prop="deliveryNo" label="快递单号"></el-table-column>
      <el-table-column prop="deliveryCompanyName" label="快递公司">
      </el-table-column>
      <el-table-column prop="deliveryTime" label="发货时间"> </el-table-column>
      <el-table-column prop="receiveTime" label="签收时间"> </el-table-column>
      <el-table-column
        prop="lastTraceNode"
        label="物流信息"
        v-if="orderDelivery.deliveryNo && orderDelivery.deliveryCompanyName"
      >
        <template slot-scope="{ row }">
          {{ row.lastTraceNode ? row.lastTraceNode.statusName : "暂无数据" }}
          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.order_list_delivery_detail)"
            type="primary"
            size="mini"
            @click="showDeliveryDetail"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="deliveryImageUrlList" label="发货图片">
        <template slot-scope="{ row }">
          <el-image
            v-show="row.deliveryImageUrlList && row.deliveryImageUrlList.length"
            style="
              width: 60px;
              height: 60px;
              margin-right: 10px;
              border-radius: 5px;
            "
            v-for="(item, i) in row.deliveryImageUrlList"
            :key="i"
            :src="item"
            :preview-src-list="[item]"
          >
          </el-image>
          <span
            v-show="
              !row.deliveryImageUrlList || !row.deliveryImageUrlList.length
            "
            >暂无数据</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="receiveImageUrlList"
        label="签收证明"
        :key="showEditButton"
      >
        <template slot="header">
          <span>签收证明</span>
          <i
            v-if="canEditDeliveryImage"
            class="el-icon-edit"
            @click="editReceiveImage('receiveImageList')"
            style="margin-left: 5px; cursor: pointer; color: #409eff"
            title="修改签收证明"
          ></i>
        </template>
        <template slot-scope="{ row }">
          <el-image
            v-show="row.receiveImageUrlList && row.receiveImageUrlList.length"
            style="
              width: 60px;
              height: 60px;
              margin-right: 10px;
              border-radius: 5px;
            "
            v-for="(item, i) in row.receiveImageUrlList"
            :key="i"
            :src="item"
            :preview-src-list="[item]"
          >
          </el-image>
          <span
            v-show="!row.receiveImageUrlList || !row.receiveImageUrlList.length"
            >暂无数据</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="holdingReceiveImageUrl" label="手持照片">
        <template slot="header">
          <span>手持照片</span>
          <i
            v-if="canEditDeliveryImage"
            class="el-icon-edit"
            @click="editReceiveImage('holdingReceiveImage')"
            style="margin-left: 5px; cursor: pointer; color: #409eff"
            title="修改手持照片"
          ></i>
        </template>
        <template slot-scope="{ row }">
          <el-image
              v-show="row.holdingReceiveImageUrl"
              style="
                width: 60px;
                height: 60px;
                margin-right: 10px;
                border-radius: 5px;
              "
              :src="row.holdingReceiveImageUrl"
              :preview-src-list="[row.holdingReceiveImageUrl]"
          >
          </el-image>
          <span v-show="!row.holdingReceiveImageUrl">暂无数据</span>
        </template>
      </el-table-column>
      <el-table-column prop="incomeImageUrl" label="收入证明">
        <template slot="header">
          <span>收入证明</span>
          <i
            v-if="canEditDeliveryImage"
            class="el-icon-edit"
            @click="editReceiveImage('incomeImage')"
            style="margin-left: 5px; cursor: pointer; color: #409eff"
            title="修改收入证明"
          ></i>
        </template>
        <template slot-scope="{ row }">
          <el-image
              v-show="row.incomeImageUrl"
              style="
                width: 60px;
                height: 60px;
                margin-right: 10px;
                border-radius: 5px;
              "
              :src="row.incomeImageUrl"
              :preview-src-list="[row.incomeImageUrl]"
          >
          </el-image>
          <span v-show="!row.incomeImageUrl">暂无数据</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="200">
        <template slot-scope="{ row }">
          {{ row.remark || "暂无数据" }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改设备串号弹窗 -->
    <el-dialog
      title="修改设备串号"
      :visible.sync="deviceSnDialog"
      width="500px"
    >
      <el-form
        ref="deviceSnForm"
        :model="deviceSnForm"
        label-width="100px"
        :rules="deviceSnRules"
      >
        <el-form-item label="设备串号" prop="deviceSn">
          <el-input
            v-model="deviceSnForm.deviceSn"
            placeholder="请输入设备串号"
            @keydown.native="($event.key === ' ' || $event.code === 'Space') && $event.preventDefault()"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deviceSnDialog = false">取消</el-button>
        <el-button type="primary" @click="submitDeviceSn">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改签收证明弹窗 -->
    <el-dialog
      :title="`修改${receiveImageConfig.label}`"
      :visible.sync="receiveImageDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="!receiveImageSubmitting"
      :show-close="!receiveImageSubmitting"
      width="600px"
    >
      <el-form
        v-if="receiveImageDialog"
        :key="receiveImageField"
        ref="receiveImageForm"
        :model="receiveImageForm"
        label-width="100px"
        :rules="receiveImageRules"
      >
        <el-form-item
          :label="receiveImageConfig.label"
          :prop="receiveImageField"
        >
          <FileUpload
            :isMulti="receiveImageConfig.multiple"
            :name.sync="receiveImageForm[receiveImageField]"
            :url.sync="receiveImagePreview"
            :disabled="receiveImageSubmitting"
            single-preview-delete
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          :disabled="receiveImageSubmitting"
          @click="receiveImageDialog = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          :loading="receiveImageSubmitting"
          @click="submitReceiveImage"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 物流信息 -->
    <el-drawer
      class="delivery-box"
      title="物流详情"
      :show-close="true"
      :withHeader="true"
      size="60%"
      :visible.sync="drawer"
      direction="rtl"
    >
      <div class="delivery-detail">
        <admin-title title="收件人信息"></admin-title>
        <el-descriptions direction="vertical" :column="5" border>
          <el-descriptions-item label="收件人">{{
            deliveryDetail.contactName
          }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{
            deliveryDetail.contactMobile
          }}</el-descriptions-item>
          <el-descriptions-item label="快递公司" :span="1">{{
            deliveryDetail.deliveryCompanyName
          }}</el-descriptions-item>
          <el-descriptions-item label="快递单号">{{
            deliveryDetail.deliveryNo
          }}</el-descriptions-item>
          <el-descriptions-item label="收货地址">{{
            deliveryDetail.contactAddress
          }}</el-descriptions-item>
        </el-descriptions>
        <admin-title title="物流信息"></admin-title>
        <div class="delivery-list" v-if="deliveryDetail.nodeList.length">
          <div
            class="item"
            v-for="(item, i) in deliveryDetail.nodeList"
            :key="i"
          >
            <div :class="['circle', i == 0 ? 'green' : '']">
              <i class="el-icon-check"></i>
            </div>
            <div :class="['dsc', i == 0 ? 'first' : '']">
              <div class="status">{{ item.statusName }}</div>
              <div class="content">{{ item.content }}</div>
              <div class="time">{{ item.time }}</div>
            </div>
          </div>
        </div>
        <div class="delivery-list" v-else>暂无数据</div>
      </div>
    </el-drawer>
  </card>
</template>

<script>
import { getDeliveryDetailAPI, editDeviceSnAPI, editDeliveryAPI } from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import FileUpload from "@/components/file-upload/index.vue";

const RECEIVE_IMAGE_CONFIG = {
  receiveImageList: {
    label: "签收证明",
    multiple: true,
  },
  holdingReceiveImage: {
    label: "手持照片",
    multiple: false,
  },
  incomeImage: {
    label: "收入证明",
    multiple: false,
  },
};

export default {
  name: "DeliveryInfo",
  mixins: [authBtnMixin],
  components: {
    FileUpload,
  },
  props: {
    orderDelivery: {
      type: Object,
      default: () => {},
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      drawer: false,
      deliveryDetail: {
        nodeList: [],
      },
      deviceSnDialog: false,
      receiveImageDialog: false,
      receiveImageField: "receiveImageList",
      receiveImagePreview: [],
      receiveImageSubmitting: false,
      deviceSnForm: {
        deviceSn: "",
      },
      receiveImageForm: {
        receiveImageList: [],
      },
      deviceSnRules: {
        deviceSn: [
          { required: true, message: "请输入设备串号", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    orderDelivery: {
      handler(newV, oldV) {
        this.address = { ...this.orderDelivery };
      },
    },
    "deviceSnForm.deviceSn"(val) {
      if (val && /\s/.test(val)) {
        this.deviceSnForm.deviceSn = val.replace(/\s/g, "");
      }
    },
  },
  computed: {
    canEditDeliveryImage() {
      return (
        !!this.showEditButton &&
        !!this.isShowBtn(this.AUTH_BTN.order_list_detail_update_delivery_receipt)
      );
    },
    receiveImageConfig() {
      return RECEIVE_IMAGE_CONFIG[this.receiveImageField];
    },
    receiveImageRules() {
      return {
        [this.receiveImageField]: [
          {
            required: true,
            type: this.receiveImageConfig.multiple ? "array" : "string",
            message: `请上传${this.receiveImageConfig.label}`,
            trigger: "change",
          },
        ],
      };
    },
    tableData() {
      return [
        {
          costPrice: this.detail.costPrice || "-",
          serialNo: this.orderDelivery.serialNo || "-",
          deliveryNo: this.orderDelivery.deliveryNo || "-",
          deliveryCompanyName: this.orderDelivery.deliveryCompanyName || "-",
          deliveryTime: this.detail.deliveryTime || "-",
          receiveTime: this.detail.receiveTime || "-",
          deliveryImageUrlList: this.orderDelivery.deliveryImageUrlList || [],
          receiveImageUrlList: this.orderDelivery.receiveImageUrlList || [],
          holdingReceiveImageUrl: this.orderDelivery.holdingReceiveImageUrl || "",
          incomeImageUrl: this.orderDelivery.incomeImageUrl || "",
          remark: this.orderDelivery.remark || "-",
          lastTraceNode: this.orderDelivery.lastTraceNode
            ? this.orderDelivery.lastTraceNode.statusName
            : "-",
        },
      ];
    },
    // 是否显示编辑按钮
    showEditButton() {
      return this.detail && this.detail.deliveryTime;
    },
  },
  mounted() {},

  methods: {
    async showDeliveryDetail() {
      this.deliveryDetail = await getDeliveryDetailAPI(this.$route.params.id);
      this.drawer = true;
    },
    editDeviceSn() {
      this.deviceSnForm.deviceSn = this.orderDelivery.serialNo || "";
      this.deviceSnDialog = true;
    },
    async submitDeviceSn() {
      this.$refs.deviceSnForm.validate(async (valid) => {
        if (valid) {
          try {
            await editDeviceSnAPI({
              orderNo: this.$route.params.id,
              deviceSn: this.deviceSnForm.deviceSn,
            });
            this.$message.success("设备串号修改成功");
            this.deviceSnDialog = false;
            // 刷新页面数据
            this.$emit("updateDetail");
          } catch (error) {
            this.$message.error("设备串号修改失败");
          }
        }
      });
    },
    editReceiveImage(field) {
      if (!this.canEditDeliveryImage || this.receiveImageSubmitting) return;
      const config = RECEIVE_IMAGE_CONFIG[field];
      if (!config) return;
      this.receiveImageField = field;
      this.receiveImageForm = {
        [field]: config.multiple ? [] : "",
      };
      this.receiveImagePreview = config.multiple ? [] : "";
      if (field === "receiveImageList") {
        const urls = this.orderDelivery.receiveImageUrlList || [];
        // 预览使用完整地址，保存使用图片标识；复制数组，避免取消编辑时影响原数据。
        const names =
          this.orderDelivery.receiveImageList ||
          urls.map((url) => new URL(url).pathname.slice(1));
        this.receiveImageForm[field] = [...names];
        this.receiveImagePreview = [...urls];
      }
      this.receiveImageDialog = true;
      this.$nextTick(() => {
        if (this.$refs.receiveImageForm) {
          this.$refs.receiveImageForm.clearValidate();
        }
      });
    },
    async submitReceiveImage() {
      if (!this.canEditDeliveryImage || this.receiveImageSubmitting) return;
      this.$refs.receiveImageForm.validate(async (valid) => {
        if (valid) {
          const field = this.receiveImageField;
          const label = this.receiveImageConfig.label;
          this.receiveImageSubmitting = true;
          try {
            await editDeliveryAPI({
              orderNo: this.$route.params.id,
              [field]: this.receiveImageForm[field],
            });
            this.$message.success(`${label}修改成功`);
            this.receiveImageDialog = false;
            // 刷新页面数据
            this.$emit("updateDetail");
          } catch (error) {
            this.$message.error(`${label}修改失败`);
          } finally {
            this.receiveImageSubmitting = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  border-color: transparent;
  margin-top: 20px;
  border-radius: 16px;
  color: #222222;
  .el-button {
    border-radius: 15px;
  }
}
.without-layout .wrapper /deep/ {
  .el-table__header .el-table__cell {
    font-weight: 600;
    color: #1a1e25;
  }
}
.delivery-box {
  .el-drawer__header {
    padding-bottom: 0;
    margin-bottom: 0;
    & > span {
      font-weight: 600;
      font-size: 17px;
    }
  }
  .delivery-detail {
    padding: 20px;
    padding-top: 0;

    .delivery-list {
      padding: 20px;
      max-height: calc(100vh - 330px);
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 3px;
        background-color: #ccc;
      }
      .item {
        position: relative;
        min-height: 100px;
        border-left: 4px solid #ccc;

        padding: 20px;
        padding-top: 0;
        &:last-child {
          border-left: none;
        }
        .circle {
          position: absolute;
          top: 0;
          left: 0;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background: #666;
          transform: translate(-53%, -10%);
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: #fff;
            font-weight: 600;
          }
        }
        .green {
          background: #66b1ff;
        }
        .dsc {
          color: #333;
          // .status {
          // }
          .content {
            margin: 10px 0;
          }
          .time {
            color: #666666;
          }
        }
        .first {
          color: #66b1ff;
          .time {
            color: #66b1ff;
          }
        }
      }
    }
  }
}
</style>
